var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogbooksInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 19.9372H21.7502V4.22852H9.6665C7.67275 4.22852 6.0415 5.85977 6.0415 7.85352V21.1448C6.0415 23.1385 7.67275 24.7698 9.6665 24.7698H21.7502V22.3535H9.6665C9.00153 22.3535 8.45778 21.8098 8.45778 21.1448C8.45892 20.481 9.00267 19.9372 9.6665 19.9372Z",
    fill: "#ADADB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogbooksInactive);
export default __webpack_public_path__ + "static/media/logbooks_inactive.4e4c498d6fd1173666e3234bf615fdc9.svg";
export { ForwardRef as ReactComponent };